export const colors = {
    primary: '#1D223F',      // Deep Navy - headers, main buttons
    accent1: '#EC7565',      // Coral - action buttons, CTAs
    accent2: '#DBF466',      // Lime - success, completed
    accent3: '#8E57D2',      // Lavender - secondary, backgrounds
    buttonBlue: '#1E90FF',   // Button Blue - primary CTA blue
    dark: '#354A17',         // Olive - text, borders

    // Background colors
    background: '#FAFAFA',
    white: '#ffffff',

    // Blue palette
    blue: {
        50: '#eff6ff',       // Very light blue background
        100: '#dbeafe',      // Light blue background
        500: '#3b82f6',      // Primary blue (buttons, links)
        600: '#2563eb',      // Darker blue (hover state)
        700: '#1e40af',      // Dark blue text
    },

    // Green palette
    green: {
        50: '#f0fdf4',       // Very light green background
        100: '#d1fae5',      // Light green background
        200: '#a7f3d0',      // Lighter green
        500: '#10b981',      // Success green (buttons, success states)
        600: '#059669',      // Medium green
        700: '#065f46',      // Dark green text
        800: '#064e3b',      // Darker green
    },

    // Red palette
    red: {
        50: '#fee2e2',       // Light red background
        200: '#fecaca',      // Lighter red
        600: '#991b1b',      // Dark red text
        700: '#ef4444',      // Error red
        800: '#991b1b',      // Darker red
    },

    // Orange palette
    orange: {
        100: '#ffedd5',      // Light orange background
        700: '#c2410c',      // Dark orange text
    },

    // Yellow palette
    yellow: {
        50: '#fefce8',       // Very light yellow background
        400: '#facc15',      // Warning yellow
    },

    // Gray palette
    gray: {
        50: '#f9fafb',
        100: '#f3f4f6',
        200: '#e5e7eb',
        300: '#d1d5db',
        400: '#9ca3af',
        600: '#6b7280',
        700: '#374151',
        900: '#111827'
    },

    // Transparent/overlay colors
    overlay: {
        dark: 'rgba(0, 0, 0, 0.5)',      // Modal backdrop
        light: 'rgba(255, 255, 255, 0.2)', // Light transparent white
        medium: 'rgba(255, 255, 255, 0.3)', // Medium transparent white
        landingBg: 'rgba(250, 249, 246, 0.9)', // Semi-transparent landing background
        coralBorder: 'rgba(255, 111, 97, 0.1)', // Light coral border
    },

    // Landing page colors
    landing: {
        bg: '#FAF9F6',           // Warm off-white background
        bgAlt: '#FFFFFF',        // Pure white sections
        text: '#1a1a1a',         // Very dark text
        textMuted: '#4a4a4a',    // Medium dark text
        textLight: '#888',       // Light gray text
        coral: '#FF6F61',        // Primary coral/salmon
        coralLight: '#FF8F85',   // Light coral
        salmon: '#FFA07A',       // Light salmon
        darkBg: '#1a1a1a',       // Dark section background
        darkBgAlt: '#2a2a2a',    // Darker shade
    },

    // Landing page gradients
    gradients: {
        coral: 'linear-gradient(135deg, #FF6F61 0%, #FF8F85 100%)',
        coralExtended: 'linear-gradient(135deg, #FF6F61 0%, #FFA07A 100%)',
        dark: 'linear-gradient(135deg, #1a1a1a 0%, #2a2a2a 100%)',
        coralGlow: 'linear-gradient(90deg, transparent, rgba(255, 111, 97, 0.1), transparent)',
        whiteGlow: 'linear-gradient(90deg, transparent, rgba(255,255,255,0.3), transparent)',
    },

    // Radial gradients for backgrounds
    radialGradients: {
        coralLight: 'radial-gradient(circle, rgba(255, 111, 97, 0.15) 0%, transparent 70%)',
        salmonLight: 'radial-gradient(circle, rgba(255, 160, 122, 0.15) 0%, transparent 70%)',
        coralMedium: 'radial-gradient(circle, rgba(255, 111, 97, 0.2) 0%, transparent 70%)',
        salmonMedium: 'radial-gradient(circle, rgba(255, 160, 122, 0.2) 0%, transparent 70%)',
    }
};

export const spacing = {
    xs: '8px',
    sm: '16px',
    md: '24px',
    lg: '32px',
    xl: '48px',
    xxl: '64px'
};

export const shadows = {
    sm: '0 1px 3px rgba(0,0,0,0.08)',
    md: '0 2px 8px rgba(0,0,0,0.08)',
    lg: '0 4px 12px rgba(0,0,0,0.12)',
    xl: '0 8px 24px rgba(0,0,0,0.15)',
    // Landing page specific shadows
    coralSm: '0 10px 30px rgba(255, 111, 97, 0.3)',
    coralMd: '0 15px 40px rgba(255, 111, 97, 0.4)',
    coralLg: '0 20px 60px rgba(255, 111, 97, 0.15)'
};

export const borderRadius = {
    sm: '4px',
    md: '8px',
    lg: '12px',
    xl: '16px',
    full: '9999px'
};

export const fonts = {
    primary: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
    secondary: "'Nunito', sans-serif",
    display: "'Abril Fatface', serif",
    landing: '"Onest", "Switzer", -apple-system, sans-serif',
    code: "source-code-pro, Menlo, Monaco, Consolas, 'Courier New', monospace",
    system: "-apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif"
};

export default colors;